export const cookiePromptText = {
  title: 'Enable third party cookies on tapybl for the best experience',
  info: 'To ensure tapybl operates securely and smoothly, we use cookies. Please enable third party cookies or switch to a different browser to continue. For detailed steps on enabling third party cookies, please refer to ',
  guide: 'this guide',
};
